import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as ChessboardSvg } from './assets/chessboard.svg';

const ChessboardIcon = React.forwardRef((args, ref) => <SvgIcon component={ChessboardSvg} ref={ref} {...args} />);

export default ChessboardIcon;
